__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "br2s_microfrontend_registry_internet";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "1.9.7", () => (__webpack_require__.e(1065).then(() => (() => (__webpack_require__(21065))))));
			register("axios", "1.9.0", () => (__webpack_require__.e(1832).then(() => (() => (__webpack_require__(11832))))));
			register("bignumber.js", "9.3.0", () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(60346))))));
			register("br2s-ui-common-utils-02", "2.105.0", () => (Promise.all([__webpack_require__.e(7898), __webpack_require__.e(1079), __webpack_require__.e(5646)]).then(() => (() => (__webpack_require__(1079))))));
			register("date-fns", "3.6.0", () => (__webpack_require__.e(9437).then(() => (() => (__webpack_require__(89437))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(219).then(() => (() => (__webpack_require__(70219))))));
			register("formik", "2.4.6", () => (__webpack_require__.e(5490).then(() => (() => (__webpack_require__(15490))))));
			register("html-react-parser", "5.2.3", () => (__webpack_require__.e(900).then(() => (() => (__webpack_require__(10900))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(62635))), 1);
			register("react-redux", "8.1.3", () => (__webpack_require__.e(8269).then(() => (() => (__webpack_require__(78269))))));
			register("react-router-dom", "6.30.0", () => (() => (__webpack_require__(20395))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(9466))), 1);
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(2754).then(() => (() => (__webpack_require__(42754))))));
			initExternal(77986);
			initExternal(32190);
			initExternal(22914);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};